import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import useTracking from '@gameday/utils/hooks/useTracking';
import { BaseVoteLink as PlayerVoterButton } from '../PlayerOfTheGame.style';

const VoteButton = (props) => {
    const {
        label = '',
        deviceInteraction,
        voteLink,
        trackingProps,
        handlers
    } = props;

    const Tracking = useTracking();

    const handleVotePage = useCallback((e) => {
        const anchorEl = e?.currentTarget;
        const { componentName = [], subComponentName = [] } = trackingProps;
        let trackingComponentName;

        if (subComponentName.length > 0) {
            trackingComponentName = ['Player of the Game'].concat(subComponentName);
        }

        const cfg = {
            componentName: componentName.concat(trackingComponentName),
            text: e?.target?.innerText,
            activity: 'Vote Button Click'
        };

        Tracking.track.track_click(cfg);

        if (anchorEl && deviceInteraction) {
            const link = anchorEl.getAttribute('href');
            if (deviceInteraction.webview({ url: link })) {
                e.preventDefault();
                return false;
            }
        }
    }, [deviceInteraction, trackingProps]);

    const eventHandlers = useMemo(() => ({
        onClick: () => {
            handleVotePage();
            if (handlers?.onClick) {
                handlers.onClick();
            }
        }
    }), [handleVotePage, handlers]);

    return (
        <PlayerVoterButton
            href={voteLink}
            label={label || 'Vote'}
            handlers={eventHandlers}
        />
    );
};

VoteButton.propTypes = {
    label: PropTypes.string,
    voteLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    trackingProps: PropTypes.object,
    handlers: PropTypes.object
};

export default VoteButton;
